import * as React from 'react';
import { styled } from '@glitz/react';
import { AspectRatio, createAspectRatioDecorator } from 'webapp/decorators/aspect-ratio';
import Image from 'webapp/components/image';
import { absoluteCenterDecorator } from 'webapp/decorators/center';
import { addSelectContentEventToDataLayer } from 'webapp/tracking/events/content';
import { isSvenssons } from 'webapp/theme';
import Link from 'webapp/components/Link';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';

export function BrandCard(props: NordicNest.Api.NordicNestBrandApiModel) {
  return (
    <Base
      title={props.name}
      to={props.url}
      onClick={() => addSelectContentEventToDataLayer({ id: props.id, type: 'brand_card', link: props.url })}
    >
      <ImageContainer>
        <BrandImage
          preset={'tiny'}
          sizes="40vw"
          image={props.image ?? props.logo}
          alt={props.name}
          css={!props.image && paddingDecorator}
        />
      </ImageContainer>
      <Text>
        <Title css={isSvenssons && silTitleDecorator}>{props.name}</Title>
      </Text>
    </Base>
  );
}

const Base = styled(Link, {
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  textDecoration: 'none',
  ':active': {
    textDecoration: 'none',
  },
  ':hover': {
    textDecoration: 'none',
  },
  ':visited': {
    textDecoration: 'none',
  },
});

const ImageContainer = styled.div(
  createAspectRatioDecorator(AspectRatio[isSvenssons ? '16:9' : '9:5']),
  isSvenssons && {
    ':after': {
      content: "''",
      backgroundColor: 'rgba(128, 122, 106, 0.06)',
      position: 'absolute',
      right: 0,
      left: 0,
      bottom: 0,
      top: 0,
    },
  },
);

const BrandImage = styled(Image, absoluteCenterDecorator, {
  objectFit: 'cover',
  maxHeight: '100%',
});

const Text = styled.div(
  {
    flexGrow: 1,
  },
  !isSvenssons
    ? {
        backgroundColor: t => t.monochrome.color,
        padding: { x: t => t.sharedSpacing.s, y: t => t.sharedSpacing.xs },
      }
    : {
        marginTop: t => t.sharedSpacing.m,
      },
);

const paddingDecorator = styled(
  {
    objectFit: 'contain',
    padding: {
      y: 10,
    },
  },
  isSvenssons && {
    padding: {
      xy: t => t.sharedSpacing.l,
    },
  },
);

const Title = styled.h2({
  fontSize: t => t.sharedFontSize.s,
  marginBottom: 0,
  fontFamily: t => t.fontFamily?.primary,
});

const silTitleDecorator = styled(
  createMaxSmallViewportDecorator({
    textAlign: 'center',
  }),
  {
    textTransform: 'uppercase',
  },
);
  